import { tr } from '@/lib/i18n-core';
import { money } from '@/lib/utils';
import { Badge } from '@/components/ui/primitives';

export function packageLineLabel(role: string | null | undefined, billHasPackage: boolean): { label: string; variant: 'info' | 'success' | 'outline' | 'warning' } | null {
  if (role === 'sale') return { label: tr('billing', 'package_sale'), variant: 'info' };
  if (role === 'usage') return { label: tr('billing', 'in_package'), variant: 'success' };
  if (role === 'overrun') return { label: tr('billing', 'beyond_package'), variant: 'warning' };
  if (billHasPackage) return { label: tr('billing', 'outside_package'), variant: 'outline' };
  return null;
}

export function AllowanceUse({ allowanceMinor, usedMinor }: { allowanceMinor: number; usedMinor: number }) {
  if (!(allowanceMinor > 0)) return null;
  const left = Math.max(0, allowanceMinor - usedMinor);
  return (
    <p className="flex items-center justify-between gap-2 text-sm">
      <span className="truncate">{tr('billing', 'medicines_allowance')}</span>
      <span className="shrink-0 tabular text-xs text-muted-foreground">
        {tr('billing', 'allowance_used_x_of_y_left_z', { used: money(usedMinor), total: money(allowanceMinor), left: money(left) })}
      </span>
    </p>
  );
}

export function CheckUpBadge({ name }: { name: string }) {
  return (
    <Badge variant="info" className="max-w-48 truncate">
      {tr('billing', 'check_up_x', { name })}
    </Badge>
  );
}

export function PackageLineBadge({ role, billHasPackage }: { role: string | null | undefined; billHasPackage: boolean }) {
  const tag = packageLineLabel(role, billHasPackage);
  if (!tag) return null;
  return <Badge variant={tag.variant}>{tag.label}</Badge>;
}
